const categories = [
  "Delivery",
  "Hamburguerias",
  "Pizzarias",
  "Restaurantes",
  "Bares",
  "Cafeterias",
  "Food Trucks",
  "Barracas de praia",
  "Redes gastronômicas",
];

function MarqueeGroup() {
  return (
    <div className="flex shrink-0 items-center" aria-hidden="true">
      {categories.map((name) => (
        <span key={name} className="flex items-center">
          <span className="px-6 text-[11px] font-semibold uppercase tracking-[0.18em] whitespace-nowrap text-foreground-700/60 md:px-10 md:text-[13px]">
            {name}
          </span>
          <span className="h-1 w-1 rotate-45 bg-primary-500" />
        </span>
      ))}
    </div>
  );
}

export default function CategoryMarquee() {
  return (
    <section
      aria-label="Categorias que usam a PlayMenu"
      className="relative border-y border-background-200 bg-white/30 py-3 md:py-4"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent md:w-32" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent md:w-32" />

      <div className="group flex overflow-hidden">
        <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused] motion-reduce:animate-none">
          <MarqueeGroup />
          <MarqueeGroup />
        </div>
      </div>
    </section>
  );
}